// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.image__popup--container {
    position: fixed;
    inset: 0px;
    z-index: 100
}
.image__popup--row {
    position: relative;
    display: flex;
    height: 100%;
    width: 100%;
    align-items: center;
    justify-content: center;
    background-color: #0000003b
}
.image__popup--col {
    position: absolute;
    z-index: 10;
    height: 80%;
    width: 80%;
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1))
}
.image__popup--wrapper {
    position: relative;
    height: 100%;
    width: 100%;
    overflow-y: scroll;
    scroll-behavior: smooth
}
.image__popup--close-btn {
    position: absolute;
    top: -0.75rem;
    right: -0.75rem;
    z-index: 10;
    cursor: pointer;
    border-radius: 9999px;
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
    padding: 0.5rem;
    --tw-text-opacity: 1;
    color: rgb(239 68 68 / var(--tw-text-opacity, 1));
    --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)
}
.image__popup--close-btn-two {
    position: absolute;
    top: -0.75rem;
    right: 0px;
    z-index: 10;
    cursor: pointer;
    border-radius: 9999px;
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
    padding: 0.25rem;
    --tw-text-opacity: 1;
    color: rgb(239 68 68 / var(--tw-text-opacity, 1));
    --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)
}
`, "",{"version":3,"sources":["webpack://./src/components/ImagePopUpV2/imagePopUp.css"],"names":[],"mappings":"AACI;IAAA,eAA4B;IAA5B,UAA4B;IAA5B;AAA4B;AAG5B;IAAA,kBAA6E;IAA7E,aAA6E;IAA7E,YAA6E;IAA7E,WAA6E;IAA7E,mBAA6E;IAA7E,uBAA6E;IAA7E;AAA6E;AAG7E;IAAA,kBAA6C;IAA7C,WAA6C;IAA7C,WAA6C;IAA7C,UAA6C;IAA7C,kBAA6C;IAA7C;AAA6C;AAG7C;IAAA,kBAA6D;IAA7D,YAA6D;IAA7D,WAA6D;IAA7D,kBAA6D;IAA7D;AAA6D;AAG7D;IAAA,kBAAoG;IAApG,aAAoG;IAApG,eAAoG;IAApG,WAAoG;IAApG,eAAoG;IAApG,qBAAoG;IAApG,kBAAoG;IAApG,4DAAoG;IAApG,eAAoG;IAApG,oBAAoG;IAApG,iDAAoG;IAApG,+EAAoG;IAApG,mGAAoG;IAApG;AAAoG;AAGpG;IAAA,kBAAmG;IAAnG,aAAmG;IAAnG,UAAmG;IAAnG,WAAmG;IAAnG,eAAmG;IAAnG,qBAAmG;IAAnG,kBAAmG;IAAnG,4DAAmG;IAAnG,gBAAmG;IAAnG,oBAAmG;IAAnG,iDAAmG;IAAnG,+EAAmG;IAAnG,mGAAmG;IAAnG;AAAmG","sourcesContent":[".image__popup--container {\n    @apply fixed inset-0 z-[100];\n}\n.image__popup--row {\n    @apply w-full h-full relative bg-[#0000003b] flex items-center justify-center;\n}\n.image__popup--col {\n    @apply absolute z-10 bg-white w-[80%] h-[80%];\n}\n.image__popup--wrapper {\n    @apply relative w-full h-full scroll-smooth overflow-y-scroll;\n}\n.image__popup--close-btn {\n    @apply absolute z-10 text-red-500 rounded-full bg-white shadow-lg p-2 -top-3 -right-3 cursor-pointer;\n}\n.image__popup--close-btn-two {\n    @apply absolute z-10 text-red-500 rounded-full bg-white shadow-lg p-1 -top-3 right-0 cursor-pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
